export function skuList(text: string): string[] {
  const skus = text.split(/\r?\n/).map(value => value.trim()).filter(Boolean);
  if (!skus.length) throw new Error('Ingresa al menos un SKU destino.');
  if (skus.length > 5000) throw new Error('El máximo es 5000 SKUs por lote.');
  if (new Set(skus).size !== skus.length) throw new Error('La lista contiene SKUs repetidos.');
  return skus;
}
export function skusFromSheet(rows: unknown[][]): string[] {
  const index = (rows[0] ?? []).findIndex(cell => typeof cell === 'string' && ['sku', 'sku destino'].includes(cell.trim().toLowerCase()));
  if (index < 0) throw new Error('La primera fila debe incluir la columna SKU destino.');
  const skus: string[] = [];
  rows.slice(1).forEach((row, i) => {
    const value = row[index];
    if (value == null || (typeof value === 'string' && !value.trim())) return;
    if (typeof value !== 'string' || /[\r\n]/.test(value)) throw new Error(`Fila ${i + 2}: el SKU debe ser texto en una sola línea. Coloca el formato de la columna "SKU destino" como Texto para poder procesar el archivo y conservar ceros y signos. Si ya ingresaste los SKUs como números, conviértelos a texto y guarda el archivo antes de volver a subirlo; cambiar solo el formato puede no convertir los valores existentes.`);
    skus.push(value.trim());
  });
  return skuList(skus.join('\n'));
}
